import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const cancelReportRequest = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'cancelReportRequest',
    stub: config.useStubbedEndpoints,
    params: {
      feRequestId: payload.feRequestId,
    },
  });

  return axios.put(serviceUrl, payload);
};

const switchToAsyncReportRequest = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'switchToAsyncReportRequest',
    stub: config.useStubbedEndpoints,
    params: {
      feRequestId: payload.feRequestId,
    },
  });

  return axios.put(serviceUrl, payload);
};

const switchToAsyncEnabled = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'switchToAsyncEnabled',
    stub: config.useStubbedEndpoints,
    params: {
      feRequestId: payload.feRequestId,
    },
  });

  return axios.get(serviceUrl, payload);
};

const cancelReportRequestEnabled = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'cancelReportRequestEnabled',
    stub: config.useStubbedEndpoints,
    params: {
      feRequestId: payload.feRequestId,
    },
  });

  return axios.get(serviceUrl, payload);
};

export default {
  cancelReportRequest,
  switchToAsyncReportRequest,
  switchToAsyncEnabled,
  cancelReportRequestEnabled,
};
